import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="trix"
export default class extends Controller {
	connect() {
		this.addTargetBlankToATags()
	}

	addTargetBlankToATags() {
		const links = this.element.querySelectorAll("a")

		links.forEach((link) => {
			// target="_blank" setzen
			link.setAttribute("target", "_blank")

			// Sicherheit hinzufügen (wichtig!)
			link.setAttribute("rel", "noopener noreferrer")
		})
	}
}
